module.exports = __webpack_public_path__ + "static/band-matt-69cb9de025f380ca023015d4645dc6dd.jpg";